import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=8cbcbd40&scoped=true&"
import script from "./resetPwd.vue?vue&type=script&lang=js&"
export * from "./resetPwd.vue?vue&type=script&lang=js&"
import style0 from "./resetPwd.vue?vue&type=style&index=0&id=8cbcbd40&scoped=true&lang=less&"
import style1 from "./resetPwd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbcbd40",
  null
  
)

export default component.exports